(function () {
  'use strict';

  // The numbered list is sticky while the spacer blocks below it scroll past
  // the bottom of the viewport. The active number is derived live from the
  // spacers' on-screen geometry on every scroll frame. Reading the geometry
  // fresh (instead of caching pixel positions, as a ScrollTrigger does) keeps
  // the highlight in sync no matter what shifts the layout afterwards — web
  // fonts loading, the background image arriving, the mobile address bar
  // showing/hiding, or orientation changes — which is what made the previous
  // implementation appear glitchy and "stuck" on mobile.
  function setupSection(section) {
    if (!section) return;

    var items = section.querySelectorAll('.scrollable-list__item');
    var spaces = section.querySelectorAll('.scrollable-list__empty_space');
    if (!items.length || !spaces.length) return;

    var count = Math.min(items.length, spaces.length);
    var current = -1;

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > count - 1) index = count - 1;
      if (index === current) return; // skip redundant DOM writes while scrolling
      current = index;
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('active', i === index);
      }
    }

    function compute() {
      var viewportBottom = window.innerHeight || document.documentElement.clientHeight;
      // Count the spacers whose top has already crossed the bottom of the
      // viewport; the last one that has is the active item. Exactly one item is
      // always active, so there are no boundary gaps where nothing is lit.
      var passed = 0;
      for (var i = 0; i < count; i++) {
        if (spaces[i].getBoundingClientRect().top <= viewportBottom) passed++;
      }
      setActive(passed - 1);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        compute();
      });
    }

    // Remove listeners from a previous setup (theme editor reloads the section).
    if (section._slCleanup) section._slCleanup();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('orientationchange', onScroll, { passive: true });
    window.addEventListener('load', compute);
    section._slCleanup = function () {
      window.removeEventListener('scroll', onScroll, { passive: true });
      window.removeEventListener('resize', onScroll, { passive: true });
      window.removeEventListener('orientationchange', onScroll, { passive: true });
      window.removeEventListener('load', compute);
    };

    compute();
  }

  function setupAll() {
    document.querySelectorAll('.scrollable-list').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = target.classList && target.classList.contains('scrollable-list')
      ? target
      : target.querySelector('.scrollable-list');
    if (section) setupSection(section);
  });
})();
